export default __webpack_public_path__ + "static/media/SAE_single_white.6b5404f6.png";